<div class="flex align-items-center justify-content-between">
  <label class="lbl mb-0">Regions</label>
  <button pButton type="button" class="p-button-text p-button-sm" icon="pi pi-pencil" label="Manage" (click)="nav.openRegions()" [disabled]="state.loading"></button>
</div>
<ul class="tally">
  <ng-container *ngFor="let r of catalogue.regions; let i = index">
    <li [class.active]="r.id === state.activeRegion && state.mode !== 'subregion'">
      <p-checkbox [binary]="true" [ngModel]="state.isRegionShown(r.id)" (ngModelChange)="state.showRegion(r.id, $event)" pTooltip="Show / hide on the map"></p-checkbox>
      <span class="swatch" [style.background]="catalogue.regionColour(r)"></span>
      <span class="name" (click)="state.engine.flyToRegion(r.id)" (dblclick)="state.activeRegion = r.id" pTooltip="Click to fly there, double-click to make it active ({{ i + 1 }})">{{ r.name }}</span>
      <span class="n">{{ (state.counts.get(r.id)?.assigned || 0) | number }}</span>
      <span class="n covered" pTooltip="With a website page">{{ (state.counts.get(r.id)?.covered || 0) | number }}</span>
    </li>
    <li *ngFor="let sr of catalogue.subRegionsOf(r.id)" class="sub" [class.active]="isActiveSubRegion(sr.id)" [attr.data-subregion]="sr.id">
      <span class="swatch ring" [style.border-color]="catalogue.subRegionColour(sr.id)"></span>
      <span class="name" (click)="state.engine.flyToSubRegion(sr.id)" (dblclick)="mapTools.editSubRegionOnMap(sr.id)" pTooltip="Click to fly there, double-click to edit it in Sub-region mode">{{ sr.name }}</span>
      <span class="n" pTooltip="Suburbs in it">{{ (state.memberCounts.get(sr.id) || 0) | number }}</span>
      <span class="n"></span>
    </li>
  </ng-container>
</ul>
<div class="meta">Assigned · <b>with a page</b>, all states. Sub-regions (indented): their suburbs.</div>
